<template>
  <DescriptorsContainer
    :ref_component="refComponent"
    :Title_text="$t('matterProgram.matterProgramView.programs')"
    :Text_info_tooltip="
      $t('matterProgram.matterProgramView.defaultDescriptorInfo')
    "
    :Title="pageTitles"
    :Descriptors="pageDescriptors"
    :allows_crud="canEdit"
    :Order="1"
    :VisibleOrder="false"
    :ProgramView="true"
    :PagePosition="page_position"
    :show_is_default="show_is_default"
    :show_add_button="show_add_button"
    drag_group="matter-program-descriptors"
    :matter="matter"
    :oldMatter="useEpmValues ? null : oldMatter"
    :can_delete="can_delete"
    :can_update="can_update"
    :can_delete_title="can_delete_title"
    @updateOrder="updateOrder"
    @moveToSection="moveToSection"
    @updateState="updateVisible"
    @createDescription="createDescription"
    @updateDescription="updateDescription"
    @createTitle="createTitle"
    @updateTitle="updateTitle"
    @deleteDescriptors="deleteDescription"
    @deleteTitle="(title) => emit('deleteTitle', title)"
  >
    <template #extra-actions>
      <slot name="extra-actions"></slot>
    </template>
  </DescriptorsContainer>
</template>

<script setup>
// eslint-plugin-vue 6.x (anterior a <script setup>) no ve que estos bindings
// se usan en el template. Quitar el disable cuando se actualice el tooling.
/* eslint-disable no-unused-vars */
// Un apartado de descriptores del programa de asignatura; la lógica vive en
// useMatterProgramDescriptors (JS plano, testeable con el jest actual).
// Legacy (Bootstrap-Vue): DescriptorsContainer es el contenedor compartido por
// todas las vistas de descriptores; este componente solo lo envuelve.
import DescriptorsContainer from "@/components/reusable/DescriptorsContainer";
import useMatterProgramDescriptors from "./useMatterProgramDescriptors";

const props = defineProps({
  page_position: {
    type: Number,
    required: true,
  },
  egress_profile_matter_id: {
    type: Number,
    default: null,
  },
  // Asignatura base cuando no hay matter (EgressProfileMatter)
  matter_id: {
    type: Number,
    default: null,
  },
  // Títulos visibles en el programa (ya filtrados por institución en el padre)
  descriptor_titles: {
    type: Array,
    default: () => [],
  },
  matter: {
    type: Object,
    default: null,
  },
  oldMatter: {
    type: Object,
    default: null,
  },
  allows_crud: {
    type: Boolean,
    default: false,
  },
  can_delete: {
    type: Boolean,
    default: false,
  },
  can_update: {
    type: Boolean,
    default: false,
  },
  can_delete_title: {
    type: [Boolean, Function],
    default: true,
  },
  show_is_default: {
    type: Boolean,
    default: true,
  },
  show_add_button: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(["titleCreated", "deleteTitle"]);

const {
  useEpmValues,
  refComponent,
  canEdit,
  pageTitles,
  pageDescriptors,
  createTitle,
  updateTitle,
  createDescription,
  updateDescription,
  updateVisible,
  updateOrder,
  moveToSection,
  deleteDescription,
} = useMatterProgramDescriptors(props, emit);
</script>
